/**
 * Image Slider
 */

import Flickity from 'flickity';

const newsList = {
    cfg: {
        slider: '.js-newsList',
        sliderOptions: {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            friction: 1,
            lazyLoad: 2,
            selectedAttraction: 0.1,
            groupCells: false,
            setGallerySize: true,
            imagesLoaded: true,
            prevNextButtons: true,
            pageDots: true,
            wrapAround: false,
            // watchCSS: true

        },
        viewportWidth: '',
        sliders: '',
        flkty: ''
    },

    flickity() {
        this.cfg.sliders = [...document.querySelectorAll(this.cfg.slider)];

        if (this.cfg.sliders.length > 0) {
            // this.cfg.sliders = [...document.querySelectorAll(this.cfg.slider)];
            this.cfg.flkty.destroy();

            if (this.cfg.sliders.length > 0) {
                this.cfg.sliders.forEach((slider) => {
                    if (window.innerWidth || document.documentElement.clientWidth >= 800) {
                        this.cfg.flkty.destroy();
                        setTimeout(() => {
                            this.cfg.flkty.resize();
                            slider.classList.remove('is-ready');
                        }, 1000);
                    } else {
                        this.cfg.flkty = new Flickity(slider, this.cfg.sliderOptions);

                        this.cfg.flkty.resize();

                        setTimeout(() => {
                            this.cfg.flkty.resize();
                            slider.classList.add('is-ready');
                        }, 1000);
                    }
                });
            }
        }
    },

    init() {
        // this.flickity();
        // window.addEventListener('load', this.flickity);
        // window.addEventListener('resize', this.flickity);

        /* window.addEventListener('load', () => {
            const sliders = [...document.querySelectorAll(this.cfg.slider)];
            if (sliders) {
                sliders.forEach((slider) => {
                    const flkty = new Flickity(slider, this.cfg.sliderOptions);
                    flkty.resize();

                    setTimeout(() => {
                        flkty.resize();
                        slider.classList.add('is-ready');
                    }, 1000);
                });
            }
        }); */
    }
};

export default newsList;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/newsList/_script.js